import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetProductionSpaceTypeQueryVariables = Types.Exact<{
  productionSpaceTypeId: Types.Scalars['String']['input'];
}>;


export type GetProductionSpaceTypeQuery = { __typename?: 'Query', productionSpaceType?: { __typename?: 'ProductionSpaceTypeStateData', tenantId: string, productionSpaceTypeId: string, code: string, status: Types.ProductionSpaceTypeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null };

export type GetProductionSpaceTypesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionSpaceTypeDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionSpaceTypeDocumentSortInput> | Types.ProductionSpaceTypeDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionSpaceTypesQuery = { __typename?: 'Query', productionSpaceTypes?: { __typename?: 'ProductionSpaceTypesConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionSpaceTypeDocument', id: string, tenantId: string, productionSpaceTypeId: string, code: string, status: Types.ProductionSpaceTypeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionSpaceCategoriesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionSpaceCategoryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionSpaceCategoryDocumentSortInput> | Types.ProductionSpaceCategoryDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionSpaceCategoriesQuery = { __typename?: 'Query', productionSpaceCategories?: { __typename?: 'ProductionSpaceCategoriesConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionSpaceCategoryDocument', id: string, tenantId: string, productionSpaceCategoryId: string, code: string, status: Types.ProductionSpaceCategoryStatus, defaultLength?: number | null, defaultWidth?: number | null, defaultStagger: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, dimensionOverrides: Array<{ __typename?: 'ProductionSpaceCategoryDimensionOverrideData', siteLocationId?: string | null, customerId?: string | null, spaceTypeId?: string | null, length: number, width: number, stagger: boolean }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionSpaceCategoryQueryVariables = Types.Exact<{
  productionSpaceCategoryId: Types.Scalars['String']['input'];
}>;


export type GetProductionSpaceCategoryQuery = { __typename?: 'Query', productionSpaceCategory?: { __typename?: 'ProductionSpaceCategoryStateData', tenantId: string, productionSpaceCategoryId: string, code: string, length: number, width: number, stagger: boolean, status: Types.ProductionSpaceCategoryStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string } | null };

export type GetEffectiveSpaceCategoryDimensionsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionSpaceCategoryDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  siteLocationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  customerId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  spaceTypeId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetEffectiveSpaceCategoryDimensionsQuery = { __typename?: 'Query', productionSpaceCategories?: { __typename?: 'ProductionSpaceCategoriesConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionSpaceCategoryDocument', productionSpaceCategoryId: string, code: string, effectiveDimensions?: { __typename?: 'SpaceCategoryDimensionsData', length: number, width: number, stagger: boolean } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type SpaceUtilizationQueryVariables = Types.Exact<{
  siteLocationId: Types.Scalars['String']['input'];
  isoYear?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isoWeekStart?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isoWeekEnd?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  locationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  spaceTypeId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  productionPlanId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SpaceUtilizationQuery = { __typename?: 'Query', spaceUtilization: Array<{ __typename?: 'SpaceCapacityRow', tenantId: string, siteLocationId: string, siteLocationName: string, locationId: string, locationName: string, spaceTypeId: string, spaceTypeCode: string, productionPlanId: string, productionPlanName: string, isoYear: number, isoWeek: number, totalAvailable: number, totalUsed: number, remaining: number, capacityPct?: number | null, capacityCovered: boolean }> };

export type SpaceUtilizationAllSitesQueryVariables = Types.Exact<{
  fromIsoYearWeek: Types.Scalars['Int']['input'];
  toIsoYearWeek: Types.Scalars['Int']['input'];
  spaceTypeId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  productionPlanId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SpaceUtilizationAllSitesQuery = { __typename?: 'Query', spaceUtilizationAllSites: Array<{ __typename?: 'SpaceSiteWeekRow', siteLocationId: string, siteLocationName: string, spaceTypeId: string, spaceTypeCode: string, isoYear: number, isoWeek: number, totalAvailable: number, totalUsed: number, remaining: number, capacityPct?: number | null, capacityCovered: boolean, byRegion: Array<{ __typename?: 'SpaceRegionUsage', customerGroupId?: string | null, customerGroupName?: string | null, totalUsed: number }> }> };

export type SpaceSiteWeekRowFragment = { __typename?: 'SpaceSiteWeekRow', siteLocationId: string, siteLocationName: string, spaceTypeId: string, spaceTypeCode: string, isoYear: number, isoWeek: number, totalAvailable: number, totalUsed: number, remaining: number, capacityPct?: number | null, capacityCovered: boolean, byRegion: Array<{ __typename?: 'SpaceRegionUsage', customerGroupId?: string | null, customerGroupName?: string | null, totalUsed: number }> };

export type SpaceUtilizationDrilldownQueryVariables = Types.Exact<{
  siteLocationId: Types.Scalars['String']['input'];
  isoYear?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isoWeekStart?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isoWeekEnd?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  locationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  spaceTypeId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  productionPlanId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SpaceUtilizationDrilldownQuery = { __typename?: 'Query', spaceUtilization: Array<{ __typename?: 'SpaceCapacityRow', tenantId: string, siteLocationId: string, siteLocationName: string, locationId: string, locationName: string, spaceTypeId: string, spaceTypeCode: string, productionPlanId: string, productionPlanName: string, isoYear: number, isoWeek: number, totalAvailable: number, totalUsed: number, remaining: number, capacityPct?: number | null, capacityCovered: boolean, trendBuckets: Array<{ __typename?: 'SpaceTrendBucket', weekLabel: string, weekStart: string, utilizationPct: number }>, bySpaceType: Array<{ __typename?: 'SpaceTypeUtilization', spaceTypeId: string, spaceTypeName: string, utilizationPct: number }>, byProductionPlan: Array<{ __typename?: 'SpacePlanLoad', productionPlanId: string, planName: string, qty: number, startDate: string, endDate: string }> }> };

export type SpaceUtilizationPreviewQueryVariables = Types.Exact<{
  siteLocationId: Types.Scalars['String']['input'];
  isoYear?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isoWeekStart?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isoWeekEnd?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  locationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  spaceTypeId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  productionPlanId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  moves?: Types.InputMaybe<Array<Types.SpaceMoveInput> | Types.SpaceMoveInput>;
}>;


export type SpaceUtilizationPreviewQuery = { __typename?: 'Query', spaceUtilizationPreview: { __typename?: 'SpaceUtilizationPreview', rows: Array<{ __typename?: 'SpaceCapacityPreviewRow', usedBefore: number, usedAfter: number, remainingAfter: number, row: { __typename?: 'SpaceCapacityRow', tenantId: string, siteLocationId: string, siteLocationName: string, locationId: string, locationName: string, spaceTypeId: string, spaceTypeCode: string, productionPlanId: string, productionPlanName: string, isoYear: number, isoWeek: number, totalAvailable: number, totalUsed: number, remaining: number, capacityPct?: number | null, capacityCovered: boolean } }>, violations: Array<{ __typename?: 'SpaceCapacityViolation', locationId: string, spaceTypeId: string, productionPlanId: string, isoWeek: number, isoYear: number, capacity: number, usedAfter: number, overBy: number }>, moves: Array<{ __typename?: 'SpaceMovePreview', productionJobId: string, lotId: string, toLocationId?: string | null, toWeekStartIso?: string | null, jobExists: boolean, jobArchived: boolean, targetLocationValid: boolean, targetWeekValid: boolean, changedSinceStaged: boolean, isValid: boolean }> } };

export type GetPlanBuilderSpacePreviewQueryVariables = Types.Exact<{
  siteLocationId: Types.Scalars['String']['input'];
  isoYear?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isoWeekStart?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isoWeekEnd?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  newLots?: Types.InputMaybe<Array<Types.SpaceNewLotInput> | Types.SpaceNewLotInput>;
}>;


export type GetPlanBuilderSpacePreviewQuery = { __typename?: 'Query', spaceUtilizationPreview: { __typename?: 'SpaceUtilizationPreview', rows: Array<{ __typename?: 'SpaceCapacityPreviewRow', usedBefore: number, usedAfter: number, row: { __typename?: 'SpaceCapacityRow', tenantId: string, siteLocationId: string, siteLocationName: string, locationId: string, locationName: string, spaceTypeId: string, spaceTypeCode: string, productionPlanId: string, productionPlanName: string, isoYear: number, isoWeek: number, totalAvailable: number, totalUsed: number, remaining: number, capacityPct?: number | null, capacityCovered: boolean } }> } };

export type SpaceUtilizationPreviewFieldsFragment = { __typename?: 'SpaceUtilizationPreview', rows: Array<{ __typename?: 'SpaceCapacityPreviewRow', usedBefore: number, usedAfter: number, remainingAfter: number, row: { __typename?: 'SpaceCapacityRow', tenantId: string, siteLocationId: string, siteLocationName: string, locationId: string, locationName: string, spaceTypeId: string, spaceTypeCode: string, productionPlanId: string, productionPlanName: string, isoYear: number, isoWeek: number, totalAvailable: number, totalUsed: number, remaining: number, capacityPct?: number | null, capacityCovered: boolean } }>, violations: Array<{ __typename?: 'SpaceCapacityViolation', locationId: string, spaceTypeId: string, productionPlanId: string, isoWeek: number, isoYear: number, capacity: number, usedAfter: number, overBy: number }>, moves: Array<{ __typename?: 'SpaceMovePreview', productionJobId: string, lotId: string, toLocationId?: string | null, toWeekStartIso?: string | null, jobExists: boolean, jobArchived: boolean, targetLocationValid: boolean, targetWeekValid: boolean, changedSinceStaged: boolean, isValid: boolean }> };

export type ProductionSpaceTypeSummaryFragment = { __typename?: 'ProductionSpaceTypeDocument', id: string, tenantId: string, productionSpaceTypeId: string, code: string, status: Types.ProductionSpaceTypeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string };

export type ProductionSpaceTypeDetailsFragment = { __typename?: 'ProductionSpaceTypeStateData', tenantId: string, productionSpaceTypeId: string, code: string, status: Types.ProductionSpaceTypeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string };

export type ProductionSpaceCategorySummaryFragment = { __typename?: 'ProductionSpaceCategoryDocument', id: string, tenantId: string, productionSpaceCategoryId: string, code: string, status: Types.ProductionSpaceCategoryStatus, defaultLength?: number | null, defaultWidth?: number | null, defaultStagger: boolean, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, dimensionOverrides: Array<{ __typename?: 'ProductionSpaceCategoryDimensionOverrideData', siteLocationId?: string | null, customerId?: string | null, spaceTypeId?: string | null, length: number, width: number, stagger: boolean }> };

export type ProductionSpaceCategoryDetailsFragment = { __typename?: 'ProductionSpaceCategoryStateData', tenantId: string, productionSpaceCategoryId: string, code: string, length: number, width: number, stagger: boolean, status: Types.ProductionSpaceCategoryStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string };

export type SpaceCapacityRowFragment = { __typename?: 'SpaceCapacityRow', tenantId: string, siteLocationId: string, siteLocationName: string, locationId: string, locationName: string, spaceTypeId: string, spaceTypeCode: string, productionPlanId: string, productionPlanName: string, isoYear: number, isoWeek: number, totalAvailable: number, totalUsed: number, remaining: number, capacityPct?: number | null, capacityCovered: boolean };

export type GetResolvedSpaceCapacityQueryVariables = Types.Exact<{
  siteLocationId: Types.Scalars['String']['input'];
  subLocationId: Types.Scalars['String']['input'];
  spaceTypeId: Types.Scalars['String']['input'];
  isoYear: Types.Scalars['Int']['input'];
  isoWeek: Types.Scalars['Int']['input'];
}>;


export type GetResolvedSpaceCapacityQuery = { __typename?: 'Query', resolvedSpaceCapacity?: { __typename?: 'ResolvedSpaceCapacity', amount: number, reliefFraction: number, source: Types.SpaceCapacitySource, creditedSubLocationId: string, creditedSubLocationName?: string | null } | null };

export type SpaceCapacityRowDrilldownFragment = { __typename?: 'SpaceCapacityRow', tenantId: string, siteLocationId: string, siteLocationName: string, locationId: string, locationName: string, spaceTypeId: string, spaceTypeCode: string, productionPlanId: string, productionPlanName: string, isoYear: number, isoWeek: number, totalAvailable: number, totalUsed: number, remaining: number, capacityPct?: number | null, capacityCovered: boolean, trendBuckets: Array<{ __typename?: 'SpaceTrendBucket', weekLabel: string, weekStart: string, utilizationPct: number }>, bySpaceType: Array<{ __typename?: 'SpaceTypeUtilization', spaceTypeId: string, spaceTypeName: string, utilizationPct: number }>, byProductionPlan: Array<{ __typename?: 'SpacePlanLoad', productionPlanId: string, planName: string, qty: number, startDate: string, endDate: string }> };

export type SpaceTrendBucketFieldsFragment = { __typename?: 'SpaceTrendBucket', weekLabel: string, weekStart: string, utilizationPct: number };

export type SpaceTypeUtilizationFieldsFragment = { __typename?: 'SpaceTypeUtilization', spaceTypeId: string, spaceTypeName: string, utilizationPct: number };

export type SpacePlanLoadFieldsFragment = { __typename?: 'SpacePlanLoad', productionPlanId: string, planName: string, qty: number, startDate: string, endDate: string };

export type GetProductionSpaceCategoryOptionsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.ProductionSpaceCategoryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionSpaceCategoryDocumentSortInput> | Types.ProductionSpaceCategoryDocumentSortInput>;
}>;


export type GetProductionSpaceCategoryOptionsQuery = { __typename?: 'Query', productionSpaceCategories?: { __typename?: 'ProductionSpaceCategoriesConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionSpaceCategoryDocument', productionSpaceCategoryId: string, code: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export const SpaceSiteWeekRowFragmentDoc = new TypedDocumentString(`
    fragment SpaceSiteWeekRow on SpaceSiteWeekRow {
  siteLocationId
  siteLocationName
  spaceTypeId
  spaceTypeCode
  isoYear
  isoWeek
  totalAvailable
  totalUsed
  remaining
  capacityPct
  capacityCovered
  byRegion {
    customerGroupId
    customerGroupName
    totalUsed
  }
}
    `, {"fragmentName":"SpaceSiteWeekRow"});
export const SpaceCapacityRowFragmentDoc = new TypedDocumentString(`
    fragment SpaceCapacityRow on SpaceCapacityRow {
  tenantId
  siteLocationId
  siteLocationName
  locationId
  locationName
  spaceTypeId
  spaceTypeCode
  productionPlanId
  productionPlanName
  isoYear
  isoWeek
  totalAvailable
  totalUsed
  remaining
  capacityPct
  capacityCovered
}
    `, {"fragmentName":"SpaceCapacityRow"});
export const SpaceUtilizationPreviewFieldsFragmentDoc = new TypedDocumentString(`
    fragment SpaceUtilizationPreviewFields on SpaceUtilizationPreview {
  rows {
    row {
      ...SpaceCapacityRow
    }
    usedBefore
    usedAfter
    remainingAfter
  }
  violations {
    locationId
    spaceTypeId
    productionPlanId
    isoWeek
    isoYear
    capacity
    usedAfter
    overBy
  }
  moves {
    productionJobId
    lotId
    toLocationId
    toWeekStartIso
    jobExists
    jobArchived
    targetLocationValid
    targetWeekValid
    changedSinceStaged
    isValid
  }
}
    fragment SpaceCapacityRow on SpaceCapacityRow {
  tenantId
  siteLocationId
  siteLocationName
  locationId
  locationName
  spaceTypeId
  spaceTypeCode
  productionPlanId
  productionPlanName
  isoYear
  isoWeek
  totalAvailable
  totalUsed
  remaining
  capacityPct
  capacityCovered
}`, {"fragmentName":"SpaceUtilizationPreviewFields"});
export const ProductionSpaceTypeSummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionSpaceTypeSummary on ProductionSpaceTypeDocument {
  id
  tenantId
  productionSpaceTypeId
  code
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"ProductionSpaceTypeSummary"});
export const ProductionSpaceTypeDetailsFragmentDoc = new TypedDocumentString(`
    fragment ProductionSpaceTypeDetails on ProductionSpaceTypeStateData {
  tenantId
  productionSpaceTypeId
  code
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"ProductionSpaceTypeDetails"});
export const ProductionSpaceCategorySummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionSpaceCategorySummary on ProductionSpaceCategoryDocument {
  id
  tenantId
  productionSpaceCategoryId
  code
  status
  defaultLength
  defaultWidth
  defaultStagger
  dimensionOverrides {
    siteLocationId
    customerId
    spaceTypeId
    length
    width
    stagger
  }
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"ProductionSpaceCategorySummary"});
export const ProductionSpaceCategoryDetailsFragmentDoc = new TypedDocumentString(`
    fragment ProductionSpaceCategoryDetails on ProductionSpaceCategoryStateData {
  tenantId
  productionSpaceCategoryId
  code
  length
  width
  stagger
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    `, {"fragmentName":"ProductionSpaceCategoryDetails"});
export const SpaceTrendBucketFieldsFragmentDoc = new TypedDocumentString(`
    fragment SpaceTrendBucketFields on SpaceTrendBucket {
  weekLabel
  weekStart
  utilizationPct
}
    `, {"fragmentName":"SpaceTrendBucketFields"});
export const SpaceTypeUtilizationFieldsFragmentDoc = new TypedDocumentString(`
    fragment SpaceTypeUtilizationFields on SpaceTypeUtilization {
  spaceTypeId
  spaceTypeName
  utilizationPct
}
    `, {"fragmentName":"SpaceTypeUtilizationFields"});
export const SpacePlanLoadFieldsFragmentDoc = new TypedDocumentString(`
    fragment SpacePlanLoadFields on SpacePlanLoad {
  productionPlanId
  planName
  qty
  startDate
  endDate
}
    `, {"fragmentName":"SpacePlanLoadFields"});
export const SpaceCapacityRowDrilldownFragmentDoc = new TypedDocumentString(`
    fragment SpaceCapacityRowDrilldown on SpaceCapacityRow {
  ...SpaceCapacityRow
  trendBuckets {
    ...SpaceTrendBucketFields
  }
  bySpaceType {
    ...SpaceTypeUtilizationFields
  }
  byProductionPlan {
    ...SpacePlanLoadFields
  }
}
    fragment SpaceCapacityRow on SpaceCapacityRow {
  tenantId
  siteLocationId
  siteLocationName
  locationId
  locationName
  spaceTypeId
  spaceTypeCode
  productionPlanId
  productionPlanName
  isoYear
  isoWeek
  totalAvailable
  totalUsed
  remaining
  capacityPct
  capacityCovered
}
fragment SpaceTrendBucketFields on SpaceTrendBucket {
  weekLabel
  weekStart
  utilizationPct
}
fragment SpaceTypeUtilizationFields on SpaceTypeUtilization {
  spaceTypeId
  spaceTypeName
  utilizationPct
}
fragment SpacePlanLoadFields on SpacePlanLoad {
  productionPlanId
  planName
  qty
  startDate
  endDate
}`, {"fragmentName":"SpaceCapacityRowDrilldown"});
export const GetProductionSpaceTypeDocument = new TypedDocumentString(`
    query GetProductionSpaceType($productionSpaceTypeId: String!) {
  productionSpaceType(productionSpaceTypeId: $productionSpaceTypeId) {
    ...ProductionSpaceTypeDetails
  }
}
    fragment ProductionSpaceTypeDetails on ProductionSpaceTypeStateData {
  tenantId
  productionSpaceTypeId
  code
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const GetProductionSpaceTypesDocument = new TypedDocumentString(`
    query GetProductionSpaceTypes($where: ProductionSpaceTypeDocumentFilterInput, $order: [ProductionSpaceTypeDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  productionSpaceTypes(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    totalCount
    nodes {
      ...ProductionSpaceTypeSummary
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment ProductionSpaceTypeSummary on ProductionSpaceTypeDocument {
  id
  tenantId
  productionSpaceTypeId
  code
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionSpaceCategoriesDocument = new TypedDocumentString(`
    query GetProductionSpaceCategories($where: ProductionSpaceCategoryDocumentFilterInput, $order: [ProductionSpaceCategoryDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  productionSpaceCategories(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    totalCount
    nodes {
      ...ProductionSpaceCategorySummary
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment ProductionSpaceCategorySummary on ProductionSpaceCategoryDocument {
  id
  tenantId
  productionSpaceCategoryId
  code
  status
  defaultLength
  defaultWidth
  defaultStagger
  dimensionOverrides {
    siteLocationId
    customerId
    spaceTypeId
    length
    width
    stagger
  }
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionSpaceCategoryDocument = new TypedDocumentString(`
    query GetProductionSpaceCategory($productionSpaceCategoryId: String!) {
  productionSpaceCategory(productionSpaceCategoryId: $productionSpaceCategoryId) {
    ...ProductionSpaceCategoryDetails
  }
}
    fragment ProductionSpaceCategoryDetails on ProductionSpaceCategoryStateData {
  tenantId
  productionSpaceCategoryId
  code
  length
  width
  stagger
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}`);
export const GetEffectiveSpaceCategoryDimensionsDocument = new TypedDocumentString(`
    query GetEffectiveSpaceCategoryDimensions($where: ProductionSpaceCategoryDocumentFilterInput, $first: Int, $after: String, $siteLocationId: String, $customerId: String, $spaceTypeId: String) {
  productionSpaceCategories(where: $where, first: $first, after: $after) {
    totalCount
    nodes {
      productionSpaceCategoryId
      code
      effectiveDimensions(
        siteLocationId: $siteLocationId
        customerId: $customerId
        spaceTypeId: $spaceTypeId
      ) {
        length
        width
        stagger
      }
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const SpaceUtilizationDocument = new TypedDocumentString(`
    query SpaceUtilization($siteLocationId: String!, $isoYear: Int, $isoWeekStart: Int, $isoWeekEnd: Int, $locationId: String, $spaceTypeId: String, $productionPlanId: String) {
  spaceUtilization(
    siteLocationId: $siteLocationId
    isoYear: $isoYear
    isoWeekStart: $isoWeekStart
    isoWeekEnd: $isoWeekEnd
    locationId: $locationId
    spaceTypeId: $spaceTypeId
    productionPlanId: $productionPlanId
  ) {
    ...SpaceCapacityRow
  }
}
    fragment SpaceCapacityRow on SpaceCapacityRow {
  tenantId
  siteLocationId
  siteLocationName
  locationId
  locationName
  spaceTypeId
  spaceTypeCode
  productionPlanId
  productionPlanName
  isoYear
  isoWeek
  totalAvailable
  totalUsed
  remaining
  capacityPct
  capacityCovered
}`);
export const SpaceUtilizationAllSitesDocument = new TypedDocumentString(`
    query SpaceUtilizationAllSites($fromIsoYearWeek: Int!, $toIsoYearWeek: Int!, $spaceTypeId: String, $productionPlanId: String) {
  spaceUtilizationAllSites(
    fromIsoYearWeek: $fromIsoYearWeek
    toIsoYearWeek: $toIsoYearWeek
    spaceTypeId: $spaceTypeId
    productionPlanId: $productionPlanId
  ) {
    ...SpaceSiteWeekRow
  }
}
    fragment SpaceSiteWeekRow on SpaceSiteWeekRow {
  siteLocationId
  siteLocationName
  spaceTypeId
  spaceTypeCode
  isoYear
  isoWeek
  totalAvailable
  totalUsed
  remaining
  capacityPct
  capacityCovered
  byRegion {
    customerGroupId
    customerGroupName
    totalUsed
  }
}`);
export const SpaceUtilizationDrilldownDocument = new TypedDocumentString(`
    query SpaceUtilizationDrilldown($siteLocationId: String!, $isoYear: Int, $isoWeekStart: Int, $isoWeekEnd: Int, $locationId: String, $spaceTypeId: String, $productionPlanId: String) {
  spaceUtilization(
    siteLocationId: $siteLocationId
    isoYear: $isoYear
    isoWeekStart: $isoWeekStart
    isoWeekEnd: $isoWeekEnd
    locationId: $locationId
    spaceTypeId: $spaceTypeId
    productionPlanId: $productionPlanId
  ) {
    ...SpaceCapacityRowDrilldown
  }
}
    fragment SpaceCapacityRow on SpaceCapacityRow {
  tenantId
  siteLocationId
  siteLocationName
  locationId
  locationName
  spaceTypeId
  spaceTypeCode
  productionPlanId
  productionPlanName
  isoYear
  isoWeek
  totalAvailable
  totalUsed
  remaining
  capacityPct
  capacityCovered
}
fragment SpaceCapacityRowDrilldown on SpaceCapacityRow {
  ...SpaceCapacityRow
  trendBuckets {
    ...SpaceTrendBucketFields
  }
  bySpaceType {
    ...SpaceTypeUtilizationFields
  }
  byProductionPlan {
    ...SpacePlanLoadFields
  }
}
fragment SpaceTrendBucketFields on SpaceTrendBucket {
  weekLabel
  weekStart
  utilizationPct
}
fragment SpaceTypeUtilizationFields on SpaceTypeUtilization {
  spaceTypeId
  spaceTypeName
  utilizationPct
}
fragment SpacePlanLoadFields on SpacePlanLoad {
  productionPlanId
  planName
  qty
  startDate
  endDate
}`);
export const SpaceUtilizationPreviewDocument = new TypedDocumentString(`
    query SpaceUtilizationPreview($siteLocationId: String!, $isoYear: Int, $isoWeekStart: Int, $isoWeekEnd: Int, $locationId: String, $spaceTypeId: String, $productionPlanId: String, $moves: [SpaceMoveInput!]) {
  spaceUtilizationPreview(
    siteLocationId: $siteLocationId
    isoYear: $isoYear
    isoWeekStart: $isoWeekStart
    isoWeekEnd: $isoWeekEnd
    locationId: $locationId
    spaceTypeId: $spaceTypeId
    productionPlanId: $productionPlanId
    moves: $moves
  ) {
    ...SpaceUtilizationPreviewFields
  }
}
    fragment SpaceUtilizationPreviewFields on SpaceUtilizationPreview {
  rows {
    row {
      ...SpaceCapacityRow
    }
    usedBefore
    usedAfter
    remainingAfter
  }
  violations {
    locationId
    spaceTypeId
    productionPlanId
    isoWeek
    isoYear
    capacity
    usedAfter
    overBy
  }
  moves {
    productionJobId
    lotId
    toLocationId
    toWeekStartIso
    jobExists
    jobArchived
    targetLocationValid
    targetWeekValid
    changedSinceStaged
    isValid
  }
}
fragment SpaceCapacityRow on SpaceCapacityRow {
  tenantId
  siteLocationId
  siteLocationName
  locationId
  locationName
  spaceTypeId
  spaceTypeCode
  productionPlanId
  productionPlanName
  isoYear
  isoWeek
  totalAvailable
  totalUsed
  remaining
  capacityPct
  capacityCovered
}`);
export const GetPlanBuilderSpacePreviewDocument = new TypedDocumentString(`
    query GetPlanBuilderSpacePreview($siteLocationId: String!, $isoYear: Int, $isoWeekStart: Int, $isoWeekEnd: Int, $newLots: [SpaceNewLotInput!]) {
  spaceUtilizationPreview(
    siteLocationId: $siteLocationId
    isoYear: $isoYear
    isoWeekStart: $isoWeekStart
    isoWeekEnd: $isoWeekEnd
    newLots: $newLots
  ) {
    rows {
      row {
        ...SpaceCapacityRow
      }
      usedBefore
      usedAfter
    }
  }
}
    fragment SpaceCapacityRow on SpaceCapacityRow {
  tenantId
  siteLocationId
  siteLocationName
  locationId
  locationName
  spaceTypeId
  spaceTypeCode
  productionPlanId
  productionPlanName
  isoYear
  isoWeek
  totalAvailable
  totalUsed
  remaining
  capacityPct
  capacityCovered
}`);
export const GetResolvedSpaceCapacityDocument = new TypedDocumentString(`
    query GetResolvedSpaceCapacity($siteLocationId: String!, $subLocationId: String!, $spaceTypeId: String!, $isoYear: Int!, $isoWeek: Int!) {
  resolvedSpaceCapacity(
    siteLocationId: $siteLocationId
    subLocationId: $subLocationId
    spaceTypeId: $spaceTypeId
    isoYear: $isoYear
    isoWeek: $isoWeek
  ) {
    amount
    reliefFraction
    source
    creditedSubLocationId
    creditedSubLocationName
  }
}
    `);
export const GetProductionSpaceCategoryOptionsDocument = new TypedDocumentString(`
    query GetProductionSpaceCategoryOptions($first: Int, $after: String, $where: ProductionSpaceCategoryDocumentFilterInput, $order: [ProductionSpaceCategoryDocumentSortInput!]) {
  productionSpaceCategories(
    first: $first
    after: $after
    where: $where
    order: $order
  ) {
    nodes {
      productionSpaceCategoryId
      code
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetProductionSpaceType: build.query<GetProductionSpaceTypeQuery, GetProductionSpaceTypeQueryVariables>({
      query: (variables) => ({ document: GetProductionSpaceTypeDocument, variables })
    }),
    GetProductionSpaceTypes: build.query<GetProductionSpaceTypesQuery, GetProductionSpaceTypesQueryVariables | void>({
      query: (variables) => ({ document: GetProductionSpaceTypesDocument, variables })
    }),
    GetProductionSpaceCategories: build.query<GetProductionSpaceCategoriesQuery, GetProductionSpaceCategoriesQueryVariables | void>({
      query: (variables) => ({ document: GetProductionSpaceCategoriesDocument, variables })
    }),
    GetProductionSpaceCategory: build.query<GetProductionSpaceCategoryQuery, GetProductionSpaceCategoryQueryVariables>({
      query: (variables) => ({ document: GetProductionSpaceCategoryDocument, variables })
    }),
    GetEffectiveSpaceCategoryDimensions: build.query<GetEffectiveSpaceCategoryDimensionsQuery, GetEffectiveSpaceCategoryDimensionsQueryVariables | void>({
      query: (variables) => ({ document: GetEffectiveSpaceCategoryDimensionsDocument, variables })
    }),
    SpaceUtilization: build.query<SpaceUtilizationQuery, SpaceUtilizationQueryVariables>({
      query: (variables) => ({ document: SpaceUtilizationDocument, variables })
    }),
    SpaceUtilizationAllSites: build.query<SpaceUtilizationAllSitesQuery, SpaceUtilizationAllSitesQueryVariables>({
      query: (variables) => ({ document: SpaceUtilizationAllSitesDocument, variables })
    }),
    SpaceUtilizationDrilldown: build.query<SpaceUtilizationDrilldownQuery, SpaceUtilizationDrilldownQueryVariables>({
      query: (variables) => ({ document: SpaceUtilizationDrilldownDocument, variables })
    }),
    SpaceUtilizationPreview: build.query<SpaceUtilizationPreviewQuery, SpaceUtilizationPreviewQueryVariables>({
      query: (variables) => ({ document: SpaceUtilizationPreviewDocument, variables })
    }),
    GetPlanBuilderSpacePreview: build.query<GetPlanBuilderSpacePreviewQuery, GetPlanBuilderSpacePreviewQueryVariables>({
      query: (variables) => ({ document: GetPlanBuilderSpacePreviewDocument, variables })
    }),
    GetResolvedSpaceCapacity: build.query<GetResolvedSpaceCapacityQuery, GetResolvedSpaceCapacityQueryVariables>({
      query: (variables) => ({ document: GetResolvedSpaceCapacityDocument, variables })
    }),
    GetProductionSpaceCategoryOptions: build.query<GetProductionSpaceCategoryOptionsQuery, GetProductionSpaceCategoryOptionsQueryVariables | void>({
      query: (variables) => ({ document: GetProductionSpaceCategoryOptionsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetProductionSpaceTypeQuery, useLazyGetProductionSpaceTypeQuery, useGetProductionSpaceTypesQuery, useLazyGetProductionSpaceTypesQuery, useGetProductionSpaceCategoriesQuery, useLazyGetProductionSpaceCategoriesQuery, useGetProductionSpaceCategoryQuery, useLazyGetProductionSpaceCategoryQuery, useGetEffectiveSpaceCategoryDimensionsQuery, useLazyGetEffectiveSpaceCategoryDimensionsQuery, useSpaceUtilizationQuery, useLazySpaceUtilizationQuery, useSpaceUtilizationAllSitesQuery, useLazySpaceUtilizationAllSitesQuery, useSpaceUtilizationDrilldownQuery, useLazySpaceUtilizationDrilldownQuery, useSpaceUtilizationPreviewQuery, useLazySpaceUtilizationPreviewQuery, useGetPlanBuilderSpacePreviewQuery, useLazyGetPlanBuilderSpacePreviewQuery, useGetResolvedSpaceCapacityQuery, useLazyGetResolvedSpaceCapacityQuery, useGetProductionSpaceCategoryOptionsQuery, useLazyGetProductionSpaceCategoryOptionsQuery } = injectedRtkApi;
